import { useEffect, useState } from "react";

/**
 * Tiny tabular clock — "alive" signal in the header.
 * Shows UTC so it matches block timestamps, with a soft pulsing dot.
 */
export function LiveClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const hh = String(now.getUTCHours()).padStart(2, "0");
  const mm = String(now.getUTCMinutes()).padStart(2, "0");
  const ss = String(now.getUTCSeconds()).padStart(2, "0");
  return (
    <span className="pill font-mono tabular-nums text-white/60">
      <span className="text-[10px] tracking-widest text-white/40">UTC</span>
      <span>
        {hh}:{mm}
        <span className="text-white/30">:{ss}</span>
      </span>
    </span>
  );
}
